module.exports = __webpack_public_path__ + "static/media/bi.ddbe8e3f.svg";